module.exports = __webpack_public_path__ + "static/logoWithText-7eb56288c61ebfac1479b0648e00b5ce.svg";